import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';

/**
 * Autorise l'accès au dashboard unique (Planificateur et Conducteur partagent
 * le même layout et les mêmes pages, cf. `app.routes.ts`) dès lors que
 * l'utilisateur authentifié possède au moins un profil applicatif valide.
 * Les actions/éléments spécifiques à un profil sont masqués au sein des
 * composants (cf. `AuthService.isPlanificateur` / `isConducteur`), pas via un
 * découpage de routes.
 */
export const hasProfileGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const roles = await authService.getUserRoles();

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }

  if (roles.length > 0) {
    return true;
  }

  return router.createUrlTree(['/auth/error']);
};
